import { configureStore } from '@reduxjs/toolkit';
import gameSessionReducer from '@mental-mint/shared-ui/Store/gameSessionSlice';
import wordCacheReducer from './Store/wordCacheSlice';

export const store = configureStore({
  reducer: {
    gameSession: gameSessionReducer,
    wordCache: wordCacheReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
